module.exports = __webpack_public_path__ + "cafb03f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_home/Pop/ic_close.png
// module id = 1240
// module chunks = 1